import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Column, FlexBox, GridContainer, Row, useScreenClass } from '@vp/swan';
import { useFeature } from '@vp/core-ui-components';
import { VatInvoiceDownloadButton } from './VatInvoiceDownloadButton';
import { PrintOrderDetailsButton } from './PrintOrderDetailsButton';
import { OrderInfoDisplay } from '../shared/OrderInfoDisplay';
import { ManageSmsSubscriptionButton } from './ManageSmsSubscriptionButton';
import { SourcePageContext } from '../contexts/SourcePageContext';
import { areAllItemsInTerminalState } from '../../util/mapStateToStatus';

const OrderCondensedSummary = ({ order, displayTextAlertModal }) => {
  const screenClass = useScreenClass();
  const orderNumber = get(order, 'orderNumber');
  const orderCreationDate = get(order, 'orderCreationDate');

  const enableTextAlertDialog = useFeature('enableImAlerts');
  const { isConfirmationPage } = useContext(SourcePageContext);

  const allItemsInTerminalState = areAllItemsInTerminalState(order);
  const orderIsAnonymous = order?.orderPlacedAnonymously;

  const showManageSubscriptionButton =
    !allItemsInTerminalState &&
    displayTextAlertModal &&
    enableTextAlertDialog &&
    !isConfirmationPage &&
    !orderIsAnonymous;

  return (
    <GridContainer>
      <Row>
        <Column span={6}>
          <OrderInfoDisplay
            orderNumber={orderNumber}
            orderCreationDate={orderCreationDate}
          />
        </Column>
        <Column
          span={['xs', 'sm', 'md'].includes(screenClass) ? 4 : 3}
          offset={['xs', 'sm', 'md'].includes(screenClass) ? 2 : 3}
          className="noprint"
        >
          <FlexBox
            gap="between-actions"
            alignItems="flex-end"
            flexDirection="column"
          >
            <PrintOrderDetailsButton order={order} />
            <VatInvoiceDownloadButton order={order} />
            {showManageSubscriptionButton && <ManageSmsSubscriptionButton />}
          </FlexBox>
        </Column>
      </Row>
    </GridContainer>
  );
};

OrderCondensedSummary.propTypes = {
  order: PropTypes.object.isRequired,
  displayTextAlertModal: PropTypes.bool.isRequired,
};

export default OrderCondensedSummary;
